import { FC } from 'react';
import { AttributeValue } from '@/api/AttributeValueApi';
import { useContent } from '@/providers/ContentProvider';

interface Props {
	attributeValue: AttributeValue;
}

export const AttributeValueDisplay: FC<Props> = ({ attributeValue }) => {
	const { getEntityText } = useContent();
	return getEntityText(attributeValue, 'displayName') || attributeValue.value;
};
